import { Button, Heading, Typography } from '@grubhubprod/gh-cookbook-react';
import { Flex, Square, Stack } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { Modal } from 'src/components/Modal/Modal';
import { useInitialModalAnalytics } from 'src/components/selfService/features/OrderHistory/ZipDownload/hooks/InitialModalAnalytics';
import { ZipFileFilters } from 'src/components/selfService/features/OrderHistory/ZipDownload/ZipDownload.utils';
import { FilterInformation } from './FilterInformation';

interface InitialModalProps {
  filters: ZipFileFilters;
  totalReceiptsToGenerate: number;
  onClose: () => void;
  onStartGeneration: () => void;
}

export function InitialModal({
  totalReceiptsToGenerate,
  filters,
  onClose,
  onStartGeneration,
}: InitialModalProps): JSX.Element {
  const { sendAnalyticsBefore } = useInitialModalAnalytics({
    eventlabel: 'success',
  });

  return (
    <Modal size="xs">
      <Square inset="md">
        <Stack y="sm">
          <Heading variant="h1">Download receipts</Heading>
        </Stack>
        <Stack aria-label="Filters">
          You'll receive a zip file with{' '}
          <Typography fontWeight="bold">{totalReceiptsToGenerate}</Typography>{' '}
          receipts for orders:
        </Stack>
        <Stack as="ul" y="sm">
          <FilterInformation filters={filters} />
        </Stack>
        <Stack y="md">This might take a few moments.</Stack>
        <Flex>
          <Stack x="x-sm" flex="1">
            <Button
              block
              variant="primary"
              buttonSize="medium"
              onClick={() =>
                sendAnalyticsBefore(onStartGeneration, {
                  eventaction: 'start receipts download_cta',
                })
              }
            >
              Start download
            </Button>
          </Stack>
          <Stack flex="1">
            <Button
              block
              variant="secondary"
              buttonSize="medium"
              onClick={onClose}
            >
              Cancel
            </Button>
          </Stack>
        </Flex>
      </Square>
    </Modal>
  );
}
